import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Button } from '@/components/ui/button';
import { CheckCircle, ChevronRight } from 'lucide-react';
import { toast } from 'sonner';
import type { Aula, ProgressoUsuario } from '@/types/masterclass';

interface SerieActionsProps {
  currentAula: Aula | null;
  nextAula: Aula | null;
  onMarkComplete: () => void;
  onNextLesson: () => void;
  progressAulas: ProgressoUsuario['aulas'];
}

export function SerieActions({
  currentAula,
  nextAula,
  onMarkComplete,
  onNextLesson,
  progressAulas,
}: SerieActionsProps) {
  useLanguage();
  if (!currentAula) return null;

  const isCompleted = currentAula && progressAulas[currentAula.id]?.status === 'concluida';

  const handleComplete = () => {
    onMarkComplete();
    toast.success(translateInterfaceText("Aula concluída! 🎉"), {
      description: nextAula
        ? translateInterfaceText("Continue para a próxima aula")
        : translateInterfaceText("Você completou esta série!"),
    });
  };

  return (
    <div className="flex flex-wrap gap-3">
      <Button
        onClick={handleComplete}
        disabled={isCompleted}
        className="gap-2"
      >
        <CheckCircle className="h-4 w-4" />
        {isCompleted ? translateInterfaceText("Aula Concluída") : translateInterfaceText("Marcar como Concluído")}
      </Button>

      {nextAula && (
        <Button variant="outline" onClick={onNextLesson} className="gap-2">
          {translateInterfaceText("Próxima Aula")}<ChevronRight className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
